<template>
  <div class="footer">
    <div class="footerImg">
      <img src="../../assets/images/Head/footer.jpg">
    </div>
    <p class="footer_color">Copyright(C)2018全日本制药株式会社All Rights Reserved</p>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue'
      }
    },
    methods: {},
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: 0px) and(max-width: 749px) {
    .footer {
      display: none;
      width: 100%;
      background-color: white;
      .footerImg {
        width: 100%;
        margin: 0 auto;
        padding: 20/$default-w+rem 0;
        img {
          width: 100%;
          height: 2.08rem;
        }
      }
    }
    .footer_color {
      margin-bottom: 50px;
      height: 50px;
      max-height: 50px;
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 13/$default-w+rem;
      color: white;
      background: $Footer_linear_ramp;
    }
  }

  @media screen and(min-width: 750px) {
    .footer {
      width: 100%;
      padding-top: 20px;
      background-color: white;
      .footerImg {
        width: 750px;
        margin: 0 auto;
        margin-bottom: 50px;
        img {
          width: 750px;
          height: 156px;
          margin: 0 auto;
        }
      }
    }
    .footer_color {
      height: 50px;
      max-height: 50px;
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 13px;
      color: white;
      background: $Footer_linear_ramp;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/Footer.vue